import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { visitorIdInsidePercentile } from 'helpers/visitorId';
import { isEmpty } from 'helpers/verify';

const FS_SDK_JS = `window._fs_debug = false;
window._fs_host = 'www.fullstory.com';
window._fs_org = '174QC';
(function(m,n,e,t,l,o,g,y){
  g=m[e]=function(a,b){g.q?g.q.push([a,b]):g._api(a,b);};g.q=[];
  o=n.createElement(t);o.async=1;o.src='https://'+_fs_host+'/s/fs.js';
  y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
  g.identify=function(i,v){g(l,{uid:i});if(v)g(l,v)};g.setUserVars=function(v){FS(l,v)};
  g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;FS(o,v)};
  g.clearUserCookie=function(d,i){d=n.domain;while(1){n.cookie='fs_uid=;domain='+d+
  ';path=/;expires='+new Date(0);i=d.indexOf('.');if(i<0)break;d=d.slice(i+1)}}
})(window,document,'FS','script','user');`;

export class FullStorySDK extends Component {
  shouldComponentUpdate(nextProps) {
    if (nextProps.currentUser && !this.props.currentUser && this.fs()) {
      this.fs().identify(String(nextProps.currentUser.id), {
        email: nextProps.currentUser.email,
      });
    }
    return false;
  }

  getSampleSizeForPath(path) {
    const { defaultSampleSize, elevatedSampleSize, elevatedPaths } = this.props;

    const isElevated = !isEmpty(elevatedPaths) && elevatedPaths.some(elevated => path.startsWith(elevated));

    return isElevated ? elevatedSampleSize : defaultSampleSize;
  }

  /* istanbul ignore next */
  fs() {
    return window.fs;
  }

  useFullStory() {
    const { currentPath, visitorId } = this.props;
    const sampleSize = this.getSampleSizeForPath(currentPath);
    return visitorIdInsidePercentile(visitorId, 0.0, sampleSize) && (!__LOCAL_DEV__ || __TEST__);
  }

  render() {
    const { currentUser } = this.props;

    if (!this.useFullStory()) {
      return false;
    }

    let userSetJs;

    if (currentUser) {
      userSetJs = `FS.identify("${currentUser.id}", {
        email: ${JSON.stringify(currentUser.email)}
      });`;
    }

    return (
      <script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: (FS_SDK_JS + userSetJs).replace(/\n/g, '') }}
      />
    );
  }
}

FullStorySDK.propTypes = {
  currentPath: PropTypes.string.isRequired,
  currentUser: PropTypes.object,
  defaultSampleSize: PropTypes.number.isRequired,
  elevatedPaths: PropTypes.array.isRequired,
  elevatedSampleSize: PropTypes.number.isRequired,
  visitorId: PropTypes.string,
};
